/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchModeResponse = {
    ExactEmail: 'CLIENT_EXACT_EMAIL',
    EmailDomain: 'CLIENT_EMAIL_DOMAIN'
} as const;
export type SearchModeResponse = typeof SearchModeResponse[keyof typeof SearchModeResponse];


export function instanceOfSearchModeResponse(value: any): boolean {
    for (const key in SearchModeResponse) {
        if (Object.prototype.hasOwnProperty.call(SearchModeResponse, key)) {
            // @ts-ignore
            if (SearchModeResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchModeResponseFromJSON(json: any): SearchModeResponse {
    return SearchModeResponseFromJSONTyped(json, false);
}

export function SearchModeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchModeResponse {
    return json as SearchModeResponse;
}

export function SearchModeResponseToJSON(value?: SearchModeResponse | null): any {
    return value as any;
}

